<template>
    <!-- show my earnings -->
    <div class="row my-3">
        <div class="col-12">
            <div class="card bg-white">
                <div class="card-body py-2">
                    <div class="clearfix">
                        <div class="float-left">
                            <h5 class="text-dark-green nav-settings-head m-0">
                                <span v-if="!showEarnings" @click="showEarnings = true" class="clickable">My Earnings</span>
                                <span v-else @click="showEarnings = false" class="clickable">My Earnings</span>
                            </h5>
                        </div>
                        <div class="float-right clickable">
                            <small v-if="!showEarnings" @click="showEarnings = true">
                                Show <i class="fas fa-eye"></i>
                            </small>
                            <small v-else @click="showEarnings = false">
                                Hide <i class="fas fa-eye-slash"></i>
                            </small>
                        </div>
                    </div>
                    <div v-if="showEarnings">
                        <p class="m-0 mt-2">
                            From the grand prize of <span class="text-dark-green font-weight-bold">N{{grandPrize | money}}</span>, 
                            currently having a global balance of 
                            <span v-if="!globalBalance" class="text-danger font-italic">calculating...</span>
                            <span v-else class="text-danger font-weight-bold">N{{globalBalance | money}}</span> 
                            <br>As of {{Date.now() | moment("MMM D YYYY hh:mm A")}}  
                            <br><span v-if="myEarnedVal">
                                Having {{myEarnedVal.totalRefEarned}} completed referrals, I earned 
                                <span class="text-dark-green font-weight-bold">N{{myEarnedVal.totalAmount | money}}</span> 
                            </span> 
                        </p> 
                        <!-- REMOVE ME ON MARCH 6TH -->
                        <div class="mt-2">
                            <small>
                                <span class="text-danger">Note: only referrals from March 6th, 2021 will be counted as valid &amp; paid for under our Refer &amp; Earn Giveaway!</span>
                            </small>
                        </div>
                        <div v-if="myPayoutInfo">
                            <hr class="my-2">
                            <div v-if="showPayoutInfo">
                                <small><i class="fas fa-university"></i> {{myPayoutInfo.bankName}}</small><br>
                                <small><i class="fas fa-wallet"></i> {{myPayoutInfo.acctNumber}}</small><br>
                                <small><i class="fas fa-user"></i> {{myPayoutInfo.acctName}}</small><br>
                                <small class="font-italic"> <i class="fas fa-edit"></i> Edit? email us {{anewitemEmail}}</small><br>
                                <small @click="showPayoutInfo = false" class="text-danger clickable"><i class="fas fa-eye-slash"></i> Hide Bank Info </small>
                            </div>
                            <div v-else>
                                <small @click="showPayoutInfo = true" class="clickable"><i class="fas fa-eye"></i> Show Bank Info </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LayoutUser from '@/layouts/User.vue'

export default {
    name: "DisplayEarnings",
    props: ['earnedObj'],
    data() {
        return {
            showEarnings: false,
            showPayoutInfo: true,
        }
    },
    methods: {
        ...mapActions(['fetchMktPayoutDetails', 'fetchCurrentGlobalBal']),
        runFetchMktPayoutDetails(theUserId) {
            if(!theUserId) return // do not run until the userId is available
            let userObj = {
                userId: theUserId
            }
            this.fetchMktPayoutDetails(userObj).then(() => {}).catch((e) => {})
        },
    },
    computed: {
        ...mapGetters(['user', 'setMktPayoutInfo', 'setGlobalBalance', 'setMktReferrals']),
        myPayoutInfo() {
            if(this.setMktPayoutInfo && this.setMktPayoutInfo !== null){
                return this.setMktPayoutInfo
            }
            return false
        },
        myEarnedVal() {
            if(this.earnedObj && this.earnedObj !== null){
                return this.earnedObj
            }
            return false
        },
        anewitemEmail() {
            return `${process.env.VUE_APP_ANI_MAIL}`
        },
        grandPrize() {
            return parseInt(process.env.VUE_APP_RAE_GRAN_PRIZE)
        },
        globalBalance() {
            if(this.setGlobalBalance && this.setGlobalBalance !== null){
                let currentGlobalBal = this.grandPrize - this.setGlobalBalance.totalAmount
                return currentGlobalBal
            }
            return false
        },
    },
    watch: {
        setMktReferrals() {
            this.fetchCurrentGlobalBal()
        }
    },
    created() {
        this.runFetchMktPayoutDetails(this.user._id)
        this.$emit('update:layout', LayoutUser);
    }
}
</script>